import { NextPage } from 'next';
import { redirect } from 'next/navigation';
import { NEXT_ROUTES } from '@bts-web/utils-next-infrastructure';
import { getCreatedSavingsPlanAction } from '../AcceptSavingsPlan/actions';

interface AcceptSavingsPlanBackwardsCompatibilityInterceptorPageProps {
  searchParams: Promise<Record<string, string>>;
}

const AcceptSavingsPlanBackwardsCompatibilityInterceptor: NextPage<
  AcceptSavingsPlanBackwardsCompatibilityInterceptorPageProps
> = async ({ searchParams }) => {
  const { savingsPlanID } = await searchParams;

  const savingsPlanPreAcceptResponse = await getCreatedSavingsPlanAction({
    savingsPlanId: savingsPlanID,
  });

  const assetId =
    savingsPlanPreAcceptResponse?.data?.preAcceptSavingsPlan?.asset?.id;

  if (!assetId || !savingsPlanID) {
    redirect(NEXT_ROUTES.ERROR_GENERIC);
  }

  redirect(
    `${NEXT_ROUTES.ASSET_DETAILS.replace('[id]', assetId)}/savings/${savingsPlanID}`,
  );
};

export { AcceptSavingsPlanBackwardsCompatibilityInterceptor };
